import type { TNotification } from "./types";
import { createPathParam, getAllPathParam, type NoPathParams } from "@/api/shared/crud";
import { createService } from "@/api/shared/service";

export * from "./types";

const SLUG = "message/notification";

export default createService(SLUG, {
  getUserNotifications: getAllPathParam<TNotification>(SLUG, undefined, {
    trailingSlash: false,
  }),
  markNotificationsAsRead: createPathParam<any, NoPathParams, void>(`${SLUG}/mark-read`, {
    trailingSlash: false,
  }),
});

// export const getUserNotifications = async () => {
//   const { data } = await HTTP.get(`api/message/notification`);
//   return data;
// };

// export const markNotificationsAsRead = async () => {
//   const { data } = await HTTP.post(`api/message/notification/mark-read`);
//   return data;
// };
